import {Logger} from "./logger";

/**
 *
 * @class ConsoleStatusReporter
 *
 * @brief provide basic logging ability where we need a status reporter.
 * Just send the messages to JavaScript console.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      December 2023
 *
 */
export class ConsoleStatusReporter {

  /** update the error line in the loader drop down */
  public status(msg: string = '') {

    Logger.info(msg);
  }

  /** update the error line in the loader drop down */
  public success(msg: string = '') {

    Logger.debug(msg);
  }

  /** update the error line in the loader drop down */
  public error(msg: string = '') {

    Logger.error(msg);
  }

}
